module.exports = __webpack_public_path__ + "static/media/noun-edit-2162449-17234d.c8f217e7.svg";